import React, { useEffect } from "react";

import AreaField from "./AreaField";
import Button from "@mui/material/Button";

import { nextCard } from "../../../../../redux/slices/CardSlices";
import { Grid } from "@mui/material";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
const AreaList = ({
  setSelectedProperties,
  nextCard,
  isInitialStateRender,
  setIsInitialStateRender,
  propertyTypes,
  setPropertyTypes,
  continueBtnChange,
}) => {
  const { t } = useTranslation();
  const countSetter = (id, operator, index) => {
    let newPropertyTypes = [...propertyTypes];
    if (operator === "increment") {
      newPropertyTypes[index].count += 1;
      let nameOfCurrentProperty = `${newPropertyTypes[index].name} ${newPropertyTypes[index].count}`;
      let propertyTypeObj = {};
      propertyTypeObj.name = nameOfCurrentProperty;
      propertyTypeObj.key = newPropertyTypes[index].count;

      propertyTypeObj.sharesData = [];

      newPropertyTypes[index].data.push(propertyTypeObj);
    } else if (operator === "decrement") {
      newPropertyTypes[index].count -= 1;
      newPropertyTypes[index].data.pop();
    }
    setPropertyTypes(newPropertyTypes);
  };
  useEffect(() => {
    const SelectedProperties = propertyTypes.filter((el) => el.count > 0);
    setSelectedProperties(SelectedProperties);
    if (SelectedProperties?.length > 0 && isInitialStateRender) {
      nextCard();
      setIsInitialStateRender(false)
    }
  }, [propertyTypes]);
  const handleClick = () => {
    const SelectedProperties = propertyTypes.filter((el) => el.count > 0);
    setSelectedProperties(SelectedProperties);
    nextCard();
  };
  const buttonflag =
    propertyTypes.length > 0 &&
    propertyTypes?.filter((el) => el.count > 0).length > 0
      ? false
      : true;

  return (
    <div className="area-list-container" style={{}}>
      <Grid
        container
        sx={{
          background: "white",
          boxShadow:
            "  0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
          padding: "1rem .8rem",
          borderRadius: "5px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          alignItems: "center",
          ["@media (max-width:450px)"]: {
            // eslint-disable-line no-useless-computed-key
          },
        }}
      >
        {propertyTypes?.length > 0 &&
          propertyTypes?.map((el, index) => {
            return (
              <Grid item lg={4} p={1} key={el.id}>
                <AreaField
                  key={el.id}
                  propertyType={el}
                  index={index}
                  countSetter={countSetter}
                />
              </Grid>
            );
          })}
        <Grid
          item
          lg={12}
          sm={12}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            ["@media (max-width:1200px)"]: {
              // eslint-disable-line no-useless-computed-key
              justifyContent: "center",
            },
          }}
        >
          <Button
            sx={{
              backgroundColor: `${
                buttonflag ? "color.dimGrey" : "color.magentaMid2"
              }`,
              color: "white",
              padding: "8px 30px",
              borderRadius: "30px",
              marginTop: "0.3rem",
              fontWeight: "900",
              border: "none",
              textTransform: "initial",
              "&:hover": {
                backgroundColor: "color.magentaLight1",
                color: "color.white",
                boxShadow: "none",
              },
            }}
            disabled={buttonflag}
            onClick={() => {
              handleClick();
              continueBtnChange();
            }}
          >
            {t("add-to-list")}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    nextCard: () => dispatch(nextCard()),
  };
}

export default connect(null, mapDispatchToProps)(AreaList);
